import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401f0bef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['dot'])
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "progress-stepper"
}
const _hoisted_4 = { class: "outer-container" }
const _hoisted_5 = { class: "top-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "divider-container" }
const _hoisted_9 = {
  key: 1,
  class: "description"
}
const _hoisted_10 = {
  key: 1,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_content_loader = _resolveComponent("base-content-loader")!
  const _component_use_svg = _resolveComponent("use-svg")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_base_content_loader, { key: 0 }))
        : (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (!_ctx.isExpanded)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExpanded = true))
                  }, [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentStepNumber), 1)
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.expandButtonText) + " ", 1),
                    _createVNode(_component_use_svg, { svg: "chevron-down" })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_ctx.steps)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(['step', { 'step--no-grow': _ctx.isLastStep(i) }]),
                              key: step.title
                            }, [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(['dot', { 'dot--inactive': _ctx.isInactive(step) }])
                                  }, [
                                    (_ctx.isCompleted(step))
                                      ? (_openBlock(), _createBlock(_component_use_svg, {
                                          key: 0,
                                          svg: "check"
                                        }))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(i + 1), 1))
                                  ], 2),
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(step.title), 1)
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                  (!_ctx.isLastStep(i))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(['divider', _ctx.hiddenDividerClass(step)])
                                      }, null, 2))
                                    : _createCommentVNode("", true),
                                  (_ctx.showStepDescription(step))
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(step.description), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ], 2))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isVerticalStepper)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.currentStepDescription), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isExpanded = false)),
                      class: "button button--collapse"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.translate('shared.collapse')) + " ", 1),
                      _createVNode(_component_use_svg, { svg: "chevron-up" })
                    ])
                  ]))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}